import * as DeviceDetector from "device-detector";
import ThemeSettings from "./theme";
import { CONSTS } from '@arkadium/modules/dist/lib/GameRenderingModule/index.consts';

export function isUnderAARPDomain(): boolean {
  try {
    return window.location.hostname.indexOf("aarp.org") !== -1;
  } catch (e) {
    console.info(e);
    return false;
  }
}

export const clone = (obj) => JSON.parse(JSON.stringify(obj));

export const isServer = typeof window === "undefined";

export function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function isMobileMode() {
  if (isServer) {
    return false;
  }
  return window.matchMedia(`(max-width: ${ThemeSettings.breakPoints.mobile}px)`)
    .matches;
}

export function loadScript(url): Promise<any> {
  return new Promise((resolve, reject) => {
    const script: any = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    if (script.readyState) {
      // IE
      script.onreadystatechange = () => {
        if (
          script.readyState === "loaded" ||
          script.readyState === "complete"
        ) {
          script.onreadystatechange = null;
          resolve(void 0);
        }
      };
    } else {
      // Others
      script.onload = resolve;
      script.onerror = reject;
    }
    script.src = url;
    document.head.appendChild(script);
  });
}

export function searchSubstring(str: string, pattern: string) {
  return new RegExp(pattern, "gi").test(str);
}

export function equalIgnoreCase(a: string, b: string) {
  return a.toLowerCase() === b.toLowerCase();
}

export function isMobileDevice() {
  const info = DeviceDetector.parse();
  if ("Mac" === info.os && hasTouchScreen()) {
    return true;
  }
  return info.type !== "Desktop";
}

export function isAdBlockEnabled(): boolean {
  return (window as any).Adv_ab === undefined;
}

function hasTouchScreen(): boolean {
  return "ontouchstart" in (window as any).document.documentElement;
}

export function fromBase64Url(value) {
  const buffer = Buffer.from(
    value.replace(/-/g, "+").replace(/_/g, "/"),
    "base64"
  );
  return buffer.toString("utf-8");
}

export function isLandscape() {
  if (isServer) {
      return false;
  }

  return window.matchMedia('(orientation:landscape)').matches;
}

export function checkFullPath(baseUrl, completionUrl) {
  if (!baseUrl || !completionUrl) {
    return "";
  }
  return completionUrl.startsWith('http') ? completionUrl : baseUrl + '/' + completionUrl;
}

export const truncatedText = (text: string, maxLength: number) => {
  if (!maxLength || text.length <= maxLength) {
    return text;
  }
  return text.substring(0, maxLength) + '...';
}

export enum IframeMessageTypes {
    PASS_GAME_DATA = 'PASS_GAME_DATA',
    UPDATE_LOCAL_STORAGE = 'UPDATE_LOCAL_STORAGE',
    REWARD_CALLBACK = 'REWARD_CALLBACK',
    POWERUP_CALLBACK = 'POWERUP_CALLBACK',
    INTERSTITIAL_CALLBACK = 'INTERSTITIAL_CALLBACK',
    RESIZE_CONTAINER = 'RESIZE_CONTAINER',
    SET_LS_ITEM = 'SET_LS_ITEM',
    REMOVE_LS_ITEM = 'REMOVE_LS_ITEM',
    AUTH_API_EVENT = 'AUTH_API_EVENT',
}

export const postMessageToIframe = (data: { type: IframeMessageTypes; payload: object }) => {
    const serializedData = JSON.parse(JSON.stringify(data));
    const iframe =
        (document.body.querySelector?.(`iframe[src^="${CONSTS.IFRAME_BASE_URL}"]`) as HTMLIFrameElement) || null;
    iframe?.contentWindow?.postMessage?.({ ...serializedData }, iframe?.src?.replace?.(/\?.*/, '') || '*');
};